// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hqpi","col":"styles_col__xKUZ_"};